import { useEffect, useState } from "react";

// Fixed top progress bar showing vertical scroll %
export default function ScrollProgress() {
  const [pct, setPct] = useState(0);
  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const scrolled = h.scrollTop / (h.scrollHeight - h.clientHeight || 1);
      setPct(Math.max(0, Math.min(1, scrolled)) * 100);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);
  return (
    <div
      className="fixed top-0 left-0 z-[60] pointer-events-none"
      style={{
        height: 2,
        width: `${pct}%`,
        background: "linear-gradient(to right, var(--accent-strong), var(--accent), var(--accent-soft))",
        transition: "width 80ms linear",
      }}
      aria-hidden="true"
    />
  );
}
